"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const cleanPostText = (text?: string) => {
  if (!text) return "";
  return text.replace(/&lt;p&gt;|&lt;\/p&gt;/g, "");
};
function BlogGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="md:col-span-2 min-h-[400px] rounded-xl bg-muted/50 animate-pulse" />
        <div className="min-h-[400px] rounded-xl bg-muted/50 animate-pulse" />
        {[...Array(3)].map((_, i) => <div key={i} className="h-[300px] rounded-xl bg-muted/50 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12">
        <p className="text-destructive font-default">در حال حاضر امکان بارگذاری مقالات وجود ندارد.</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="text-center py-12">
        <p className="text-muted-foreground font-default">هیچ مقاله‌ای یافت نشد.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {posts.map((post, i) => {
      const isFeatured = i === 0;
      if (isFeatured) {
        return <article key={post.id} data-index={i} className="md:col-span-2 relative overflow-hidden rounded-3xl group min-h-[400px] md:min-h-[480px] flex items-end shadow-lg">
              <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684933/img/psychology_featured_article.png"} alt={post.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
              <div className="relative z-10 p-6 md:p-10 w-full">
                {post.categories && post.categories.length > 0 && <Badge variant="default" className="mb-4 bg-secondary text-secondary-foreground border-none font-default">
                    {post.categories[0].name}
                  </Badge>}
                <Link to={`/post/${post.id}`} className="block">
                  <h3 className="font-default text-3xl md:text-5xl font-bold text-white mb-4 leading-tight group-hover:underline decoration-2 underline-offset-4">
                    {cleanPostText(post.title)}
                  </h3>
                </Link>
              </div>
            </article>;
      }
      return <article key={post.id} data-index={i} className="flex flex-col rounded-3xl overflow-hidden bg-card border border-border/40 transition-all duration-300 hover:bg-accent/20 hover:shadow-xl group">
            <Link to={`/post/${post.id}`} className="block aspect-[4/3] overflow-hidden">
              <img src={post.featuredImage || `/img/psychology_insight_thumb_${i}.png`} alt={post.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
            </Link>
            <div className="p-6 flex flex-col flex-1">
              {post.categories && post.categories.length > 0 && <Badge variant="outline" className="mb-4 w-fit bg-background/50 border-secondary/30 text-secondary-foreground font-default">
                  {post.categories[0].name}
                </Badge>}
              <Link to={`/post/${post.id}`} className="block mb-3">
                <h3 className="font-default text-xl md:text-2xl font-bold text-foreground leading-snug group-hover:text-secondary transition-colors">
                  {cleanPostText(post.title)}
                </h3>
              </Link>
              <p className="text-muted-foreground text-sm line-clamp-3 mb-6 font-default flex-1">
                {cleanPostText(post.excerpt) || "آموزش‌ها و راهکارهای عملی برای مدیریت اضطراب، بهبود روابط و رشد فردی تحت نظارت دکتر مهرنوش اسماعیلی."}
              </p>
              <div className="mt-auto pt-4 border-t border-border/60 flex items-center justify-between">
                <span className="text-xs text-muted-foreground font-default uppercase tracking-wider font-medium">
                  {post.date ? new Date(post.date).toLocaleDateString('fa-IR') : 'به‌روزرسانی اخیر'}
                </span>
                <Link to={`/post/${post.id}`} className="text-sm font-semibold text-secondary hover:underline font-default">
                  مطالعه بیشتر
                </Link>
              </div>
            </div>
          </article>;
    })}
    </div>;
}
export default function UltimasDoBlog() {
  const wp_query_params = {
    post_type: "post",
    per_page: 7,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="222328" id="آخرین-نوشتههای-آموزشی" className="w-full bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="mb-12 md:mb-16 text-center md:text-right flex flex-col md:flex-row-reverse md:items-end justify-between gap-6">
          <div className="max-w-2xl">
            <h2 className="font-default text-4xl md:text-5xl font-bold text-foreground mb-4">
              آخرین نوشته‌های آموزشی
            </h2>
            <p className="font-default text-lg text-muted-foreground">
              مقالات تخصصی، راهکارهای خودمراقبتی و تازه‌های دنیای روانشناسی برای ارتقای سلامت روان شما.
            </p>
          </div>
          <div className="hidden md:block">
            <Link to="/InsightsPage">
              <Button variant="outline" className="font-default rounded-lg border-secondary text-secondary hover:bg-secondary hover:text-secondary-foreground">
                مشاهده همه مقالات
              </Button>
            </Link>
          </div>
        </div>

        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 7,
        order: "desc",
        orderby: "date"
      }}>
          <BlogGridConsumer />
        </PostsProvider>

        <div className="mt-10 text-center md:hidden">
          <Link to="/InsightsPage">
            <Button variant="outline" className="font-default w-full rounded-lg border-secondary text-secondary">
              مشاهده همه مقالات
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}